import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/talk-more-icon.png'
import _imports_1 from '@/assets/img/no-image.png'
import _imports_2 from '@/assets/img/pickup-button-vector.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-618fd51d")

_pushScopeId("data-v-618fd51d")
const _hoisted_1 = { class: "talk-future" }
const _hoisted_2 = {
  key: 0,
  class: "talk-future-nothing"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "talk-headline-box" }, [
  /*#__PURE__*/_createVNode("h1", { class: "txt txt-headline talk-headline" }, "今度お話しする")
], -1)
const _hoisted_4 = { class: "talk-future-nothing-container" }
const _hoisted_5 = {
  key: 0,
  class: "txt talk-future-nothing-box"
}
const _hoisted_6 = {
  key: 1,
  class: "talk-future-exist"
}
const _hoisted_7 = { class: "talk-headline-box" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h1", { class: "txt txt-headline talk-headline" }, "今度お話しする", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "talk-more-text txt" }, "もっと見る", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "talk-more-icon",
  src: _imports_0
}, null, -1)
const _hoisted_11 = { class: "talk-future-talent-container" }
const _hoisted_12 = {
  key: 0,
  class: "talk-future-img",
  src: _imports_1
}
const _hoisted_13 = {
  key: 2,
  class: "next-live-box"
}
const _hoisted_14 = { class: "next-live-text txt txt-wt txt-detail" }
const _hoisted_15 = { class: "talent-name txt txt-small" }
const _hoisted_16 = {
  key: 0,
  class: "swiper-button-prev"
}
const _hoisted_17 = {
  key: 1,
  class: "swiper-button-next"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "talk-future-circle" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "talk-future-circle-vector",
    src: _imports_2
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Imgix = _resolveComponent("Imgix")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")
  const _component_Swiper = _resolveComponent("Swiper")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.futureTalents.length === 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            (_ctx.futureTalents.length === 0)
              ? (_openBlock(), _createBlock("p", _hoisted_5, "通話のスケジュールがここに表示されます"))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.futureTalents.length !== 0)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            (_ctx.futureTalents.length !== 0)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "talk-more-box",
                  to: { name: 'TalkFutureTalentsScreen' }
                }, {
                  default: _withId(() => [
                    _hoisted_9,
                    _hoisted_10
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_Swiper, {
              class: "talk-future-talent",
              breakpoints: _ctx.state.breakpointOptions,
              loop: false,
              navigation: _ctx.state.navigation,
              "slides-per-view": 2.6,
              "space-between": 12
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.futureTalents, (futureTalent, index) => {
                  return (_openBlock(), _createBlock(_component_SwiperSlide, {
                    key: index,
                    onClick: ($event: any) => (_ctx.openTalent(futureTalent.talentID))
                  }, {
                    default: _withId(() => [
                      (futureTalent.mainImage === '')
                        ? (_openBlock(), _createBlock("img", _hoisted_12))
                        : (_openBlock(), _createBlock(_component_Imgix, {
                            key: 1,
                            class: "talk-future-img",
                            imageUrl: futureTalent.mainImage,
                            imageSize: _ctx.imageSize
                          }, null, 8, ["imageUrl", "imageSize"])),
                      (futureTalent.liveStatus === 3)
                        ? (_openBlock(), _createBlock("div", _hoisted_13, [
                            _createVNode(_component_font_awesome_icon, {
                              class: "next-live-icon",
                              icon: ['far', 'clock']
                            }),
                            _createVNode("div", _hoisted_14, _toDisplayString(futureTalent.convertUnixToDate), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_15, _toDisplayString(futureTalent.formatDisplayNameOfTalkFutureTalents), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["breakpoints", "navigation", "slides-per-view"])
          ]),
          (_ctx.futureTalents.length === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_16))
            : _createCommentVNode("", true),
          (_ctx.futureTalents.length === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_17))
            : _createCommentVNode("", true),
          _hoisted_18
        ]))
      : _createCommentVNode("", true)
  ]))
})